export const GET_VEHICLES_SYNC_LIMIT = "GET_VEHICLES_SYNC_LIMIT";
export const VEHICLE_LIMIT_FETCH_ERROR = "VEHICLE_SYNC_LIMIT_ERROR";